import React from "react";
import Navbar from "./navbar";
import AboutHeroSection from "./AboutHeroSection";
import AboutSection from "./AboutSection";
import Process from './Process';
import Methodology from "./Methodology";
import Footer from "./Footer";
import TeamMembers from "./TeamMembers";
export default function About() {
  return (
    <>
      <Navbar />

      <AboutHeroSection />

      <div className="-mt-16 relative z-20">
        <AboutSection heading="About Us" fullWidth />
      </div>

      <Methodology />
    

      <TeamMembers />

      <Footer />
    </>
  );
}